import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { endpoints } from '../../../../environments/environment';

@Injectable()
export class TermsViewService {

  constructor(private http: HttpClient) { }

  private termCache: string;

  getTerms(): Observable<any> {
    if(this.termCache) {
      return new Observable(r => r.next(this.termCache));
    }
    return this.http.get(endpoints.utils.terms).pipe(map((data: any) => {
      this.termCache = data.Retorno;
			return data.Retorno;
		}));
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/terms-of-use/terms-view/terms-view.service.ts